import { TOrderCategorySlug } from '@/common/integrations/menhir/employee/orders/orders.types';
import {
  transformReimbursableItems,
  transformReimbursementBeneficiaries,
} from '@/common/integrations/menhir/employee/reimbursements/reimbursements.dto';
import {
  IMenhirBeneficiary,
  IMenhirReimbursableItem,
} from '@/common/integrations/menhir/employee/reimbursements/reimbursements.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  MENHIR_ENDPOINTS,
  endpointFor,
} from '@/common/integrations/menhir/menhir.endpoints';
import { IMenhirPaginationResponse } from '@/common/types/menhir/general';

export const getReimbursableItems = (category?: TOrderCategorySlug) =>
  menhirClient
    .get<
      null,
      { reimbursable_items: IMenhirPaginationResponse<IMenhirReimbursableItem> }
    >(MENHIR_ENDPOINTS.EMPLOYEE.REIMBURSEMENTS.REIMBURSABLE_ITEMS, {
      params: {
        pagination: 'no',
        type: category,
      },
    })
    .then((envelope) =>
      transformReimbursableItems(envelope.reimbursable_items.list)
    );

export const getReimbursementBeneficiaries = (category: TOrderCategorySlug) =>
  menhirClient
    .get<
      null,
      { beneficiaries: IMenhirBeneficiary[] }
    >(endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.REIMBURSEMENTS.BENEFICIARIES, category))
    .then((envelope) =>
      transformReimbursementBeneficiaries(envelope.beneficiaries)
    );
